import React from 'react'

export default () => (
  <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 1L2 7.5M2 7.5L8.5 14M2 7.5H17.5" stroke="#003A80" strokeWidth="2"/>
  </svg>

)
